"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/objectWithoutProperties"));
var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/taggedTemplateLiteral"));
var _react = _interopRequireDefault(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
require("../../foundations/color-palette");
require("../../foundations/fonts");
var _Button = _interopRequireDefault(require("../../elements/Button/Button"));
var _TwoColumnLayout = _interopRequireDefault(require("../../layouts/TwoColumnLayout/TwoColumnLayout"));
var _Link = _interopRequireDefault(require("../../elements/Link/Link"));
var _excluded = ["invertedLabel", "primaryLabel", "invertedUrl", "primaryUrl", "children", "font"];
var _templateObject;
var StyledButtonItem = (0, _styledComponents.default)(_TwoColumnLayout.default.Column)(_templateObject || (_templateObject = (0, _taggedTemplateLiteral2.default)(["\n  width: 100%;\n"])));
var ButtonGroup = function ButtonGroup(_ref) {
  var invertedLabel = _ref.invertedLabel,
    primaryLabel = _ref.primaryLabel,
    invertedUrl = _ref.invertedUrl,
    primaryUrl = _ref.primaryUrl,
    children = _ref.children,
    _ref$font = _ref.font,
    font = _ref$font === void 0 ? "lead" : _ref$font,
    props = (0, _objectWithoutProperties2.default)(_ref, _excluded);
  return _react.default.createElement(_TwoColumnLayout.default, Object.assign({
    variant: "SixSixRatio",
    spansFullPage: true,
    disableGutters: true
  }, props), _react.default.createElement(StyledButtonItem, Object.assign({
    xs: 12,
    sm: 12,
    md: 6,
    lg: 6,
    xl: 6,
    justifyContent: "center"
  }, props), _react.default.createElement(_Link.default, Object.assign({
    href: invertedUrl || '/'
  }, props), _react.default.createElement(_Button.default, Object.assign({
    font: font,
    inverted: true,
    fullWidth: true
  }, props), children || invertedLabel))), _react.default.createElement(StyledButtonItem, Object.assign({
    xs: 12,
    sm: 12,
    md: 6,
    lg: 6,
    xl: 6,
    justifyContent: "center"
  }, props), _react.default.createElement(_Link.default, Object.assign({
    href: primaryUrl || '/'
  }, props), _react.default.createElement(_Button.default, Object.assign({
    font: font,
    fullWidth: true
  }, props), children || primaryLabel))));
};
var _default = ButtonGroup;
exports.default = _default;